module.exports = __webpack_public_path__ + "img/webclip.3629cf80.png";